import useSWR from "swr";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CardUser from "./CardUser";
import './stylesComponent/Carrusel.css';
import "swiper/css";


const getTutores = async([urlUsers, urlClases, urlCursos, urlResennas]) => {
    try{
        //Hacemos las 4 peticiones en paralelo
        //Extraer todos los usuarios y filtrar por tutor
        const [usersRes, clasesRes, cursosRes, resennasRes] = await Promise.all([
            fetch(urlUsers, {
                method: "GET",
                headers: {
                'Content-Type': 'application/json', 
                },
            }),
            fetch(urlClases, {
                method: "GET",
                headers: {
                'Content-Type': 'application/json', 
                },
            }),
            fetch(urlCursos, {
                method: "GET",
                headers: {
                'Content-Type': 'application/json', 
                },
            }),
            fetch(urlResennas, {
                method: "GET",
                headers: {
                'Content-Type': 'application/json', 
                },
            }),
        ]);

        //Comprobar que todas fueron exitosas
        if(!usersRes.ok) throw new Error("Error al consultar los tutores");
        if(!clasesRes.ok || !cursosRes.ok ) throw new Error("Error al consultar el contenido del tutor");
        if (!resennasRes.ok) throw new Error("Error al consultar las reseñas del tutor");

        let [users, allClases, allCursos, allResennas] = await Promise.all([
            usersRes.json(),
            clasesRes.json(),
            cursosRes.json(),
            resennasRes.json(),
        ]);


        //Filtrar productos eliminados
        const filtrarEliminados = (prod) =>
            prod.Nombre !== null &&
            prod.Descripcion !== null &&
            prod.Tematica !== null &&
            prod.ImagenPortada !== null &&
            prod.FechaSubida !== null;

        allClases = allClases.filter(filtrarEliminados);
        allCursos = allCursos.filter(filtrarEliminados);
        
        //Agrupar reseñas por Id_Contenido
        const resByContent = allResennas.reduce((acc, r) => {
            acc[r.Id_Contenido] = acc[r.Id_Contenido] || [];
            acc[r.Id_Contenido].push(r.Valoracion);
            return acc;
        }, {});

        // Calcular rating medio de cada tutor
        const tutoresConRating = users.map((tutor) => {
            // IDs de sus productos (clases + cursos)
            const productosIds = [
                ...allClases.filter((c) => c.TutorId === tutor._id).map((c) => c._id),
                ...allCursos.filter((c) => c.TutorId === tutor._id).map((c) => c._id),
            ];

        // Ratings por producto con al menos una valoración
        const ratingsPorProducto = productosIds.map((id) => {
            const vals = resByContent[id];
            if (!vals || vals.length === 0) return null;
            const suma = vals.reduce((a, b) => a + b, 0);
            return suma / vals.length;
        }).filter((r) => r !== null); // solo productos con valoraciones

        const sumaRatings = ratingsPorProducto.reduce((a, b) => a + b, 0);
        const rating = ratingsPorProducto.length
            ? sumaRatings / ratingsPorProducto.length
            : 0;

        return { ...tutor, rating };
      });

      // Ordenar de mayor a menor rating
      return tutoresConRating.sort((a, b) => b.rating - a.rating);   
    } catch (error) {
        console.error("Error al obtener los usuarios" + error.message);
    }
};


const CarruselUser = () => {

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';
    
    //const [tutores, setTutores] = useState((null));
    const { data: tutores = [], error,  mutate: mutateUser } = useSWR(
        [`${baseUrl}/api/users?Tipo=Tutor`,
        `${baseUrl}/api/clases/`,
        `${baseUrl}/api/cursos/`,
        `${baseUrl}/api/resennas/`
    ],
    getTutores,
        { 
            dedupingInterval: 30 * 60 * 1000, //Evita llamadas repetidas por 30 min
            keepPreviousData: true, //mantener los datos anteriores  durante recarga
            revalidateOnReconnect: false, //evita recarga al reconectarse
            revalidateOnFocus: false, //evita recarga al volver al tab
         }
    );

    if (error) {
        console.error("Error al obtener los productos:", error);
    }
    
    return (
        <div className="App" style={{background: 'var(--bg-carrusel2)' }}>
            <h3>Tutores Destacados</h3>

            <div className="container">
                <div className="swiperContainer">
                    <Swiper 
                        modules={[Pagination, Autoplay]}
                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false
                        }}
                        pagination={{
                            el: ".pagination",
                            clickable: true,
                        }}
                        slidesPerView={5}
                        centeredSlides={true}
                        spaceBetween={16}
                        breakpoints={{
                            0: {
                            slidesPerView: 1,
                            spaceBetween: 16
                            },
                            536: {
                            slidesPerView: 2,
                            spaceBetween: 16
                            },
                            792: {
                            slidesPerView: 3,
                            spaceBetween: 16
                            },
                            1048: {
                            slidesPerView: 4,
                            spaceBetween: 16
                            },
                            1304: {
                            slidesPerView: 5,
                            spaceBetween: 16
                            }
                        }}
                    >
                        {tutores?.slice(0, 20).map((tutor) => (
                            <SwiperSlide key={tutor?._id}>
                                <CardUser tutor={tutor} />
                            </SwiperSlide>
                        ))}  
                        <div className="pagination"></div>   
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default CarruselUser;



